/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.timeline", {
        options: {},

        _create: function () {
            this.elem = this.element;

            this._iniVars()

            this._checkMobile()

            this._iniSlider();

            $(window).on('resize', _ => {
                this._checkMobile()

                if (!this.sliders.hasClass('slick-initialized') && !this.isMobile) {
                    this._iniSlider();
                }
            })

            this._iniTimelineNav()
        },

        _iniVars() {
            this.timelineCont = $('.s-timeline__cont', this.elem)
            this.timelineItemsWrap = $('.s-timeline__items', this.elem)
            this.groups = $('.s-timeline__group', this.elem);
            this.sliders = $('.s-timeline__group__slider', this.elem);
            this.btnPrev = $('.s-timeline__group__nav a.nav-prev', this.elem);
            this.btnNext = $('.s-timeline__group__nav a.nav-next', this.elem);

            this.timelineNav = $('.s-timeline__nav', this.elem)
            this.timelineNavList = $('.s-timeline__nav__list', this.elem)
            this.timelineNavItems = $('.s-timeline__nav__item', this.elem)
            this.timelineNavLinks = $('.s-timeline__nav__link', this.elem)
        },

        _checkMobile() {
            this.isMobile = api.vars.windW < api.vars.scr.desktop
        },

        _iniSlider() {
            this.sliders.each(function () {
                var slider = $(this);
                slider.slick({
                    edgeFriction: api.vars.slick.edgeFriction,
                    infinite: false,
                    arrows: true,
                    dots: false,
                    swipeToSlide: true,
                    rows: 0,
                    slidesToShow: 1,
                    prevArrow: slider.parents('.s-timeline__group').find('.nav-prev'),
                    nextArrow: slider.parents('.s-timeline__group').find('.nav-next'),
                    responsive: [
                        {
                            breakpoint: api.vars.scr.desktop,
                            settings: "unslick"
                        }
                    ]
                });

                slider.on('beforeChange', (slick, currentSlide, nextSlide) => {
                    slider.find('[data-src]').lazy();
                });

                slider.on('afterChange', (slick, currentSlide) => {
                    slider.find('[data-src]').lazy();
                })
            })
        },

        _iniTimelineNav() {
            var self = this;

            this.timelineNavLinks.on('click', function(e) {
                e.preventDefault()

                var link = $(this);
                var target = self.groups.filter(`[id="${link.attr('href').substr(1)}"]`)
                self.scrollToGroup(target)
            })

            setTimeout(_ => {
                this._checkStickyTimelineNav()
                this._checkActiveGroup()
            })

            $(window).on('resize', _ => {
                this._checkStickyTimelineNav()
                this._checkActiveGroup()
            })
            $(window).on('scroll', _ => {
                if (!this.isMobile) {
                    this._checkStickyTimelineNav()
                    this._checkActiveGroup()

                    setTimeout(_ => {
                        this._checkStickyTimelineNav()
                        this._checkActiveGroup()
                    }, 280)
                }
            })

            this.timelineItemsWrap.on('scroll', _ => {
                this._checkActiveGroup()
                this.timelineItemsWrap.find('[data-src]').lazy();
            })
        },

        _checkStickyTimelineNav: function () {
            if (this.isMobile) {
                return;
            }

            var header = $('.header__layer');

            var timelineItemsWrapHeight = this.timelineItemsWrap.outerHeight();
            var minTopPosition = this.timelineItemsWrap.offset().top;
            var maxTopPosition = minTopPosition + timelineItemsWrapHeight

            var timelineNavHeight = this.timelineNav.outerHeight();
            var topElementsHeight = header.hasClass('nav-down') ? header.outerHeight() : 0
            var scrollOffset = $(window).scrollTop()
            var stickyPosition = scrollOffset + topElementsHeight + (api.vars.windH - topElementsHeight) / 2 - timelineNavHeight / 2;

            if (stickyPosition >= minTopPosition && stickyPosition + timelineNavHeight <= maxTopPosition) {
                this.timelineNav.css({
                    'position': 'fixed',
                    "top": Number(stickyPosition - scrollOffset) + "px",
                    "left": this.timelineCont.offset().left + "px",
                    "width": this.timelineCont.width() - this.timelineItemsWrap.width()
                }).addClass('is-sticky')
            }
            else if (stickyPosition < minTopPosition) {
                this.timelineNav.css({
                    'position': 'absolute',
                    "top": 0,
                    "left": this.timelineCont.offset().left + "px",
                    "width": this.timelineCont.width() - this.timelineItemsWrap.width()
                }).removeClass('is-sticky')
            }
            else if (stickyPosition + timelineNavHeight > maxTopPosition) {
                this.timelineNav.css({
                    'position': 'absolute',
                    "top": timelineItemsWrapHeight - timelineNavHeight + "px",
                    "left": this.timelineCont.offset().left + "px",
                    "width": this.timelineCont.width() - this.timelineItemsWrap.width()
                }).removeClass('is-sticky')
            }

        },

        _checkActiveGroup() {
            var checkpoint = !this.isMobile
                ? $(window).scrollTop() + api.vars.windH / 2
                : this.timelineItemsWrap.offset().left

            this.groups.each((i) => {
                var group = this.groups.eq(i);
                var groupStart = !this.isMobile
                    ? group.offset().top
                    : group.offset().left
                var groupEnd = !this.isMobile
                    ? groupStart + group.outerHeight()
                    : groupStart + group.outerWidth()

                if (checkpoint >= groupStart && checkpoint < groupEnd) {
                    this.activateGroup(group)
                }
            })
        },

        scrollToGroup(group) {
            if (group.length) {
                if (!this.isMobile) {
                    var offset = group.offset().top > $(window).scrollTop() ? $('.header').outerHeight() : 0
                    api.fn.moveWindowToObj(group, offset - 30)
                }
                else {
                    var scrollMove = group.offset().left + this.timelineItemsWrap.scrollLeft() - this.timelineItemsWrap.offset().left

                    this.timelineItemsWrap.clearQueue();
                    this.timelineItemsWrap
                        .stop()
                        .animate({ scrollLeft: scrollMove },400);

                    api.fn.moveWindowToObj(this.timelineItemsWrap, -60)
                }
            }
        },

        activateGroup(group) {
            var groupId = group.attr('id')

            var groupNavItem = this.timelineNavLinks.filter(`[href='#${groupId}']`).parent()

            this.timelineNavItems.removeClass('active')

            if (groupNavItem.length) {
                groupNavItem.addClass('active')

                $('.s-timeline__group__period.mob-info').text(group.find('.s-timeline__group__period').text())
                $('.s-timeline__group__title.mob-info').text(group.find('.s-timeline__group__title').text())

                if (this.isMobile) {
                    var scrollMove = groupNavItem.offset().left + this.timelineNav.scrollLeft() - 20
                    this.timelineNav.clearQueue();
                    this.timelineNav
                        .stop()
                        .animate({ scrollLeft: scrollMove }, 400);
                }
            }
            
        }


    });
})(jQuery);
